import React from 'react';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import RootRouters from './RootRouters/rootRouters';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/core';
import { theme } from './App.styles';
// pick a date util library
import DateFnsUtils from '@date-io/date-fns';
import { SocketContext, socket } from './Services/socket';
import './App.css';
import './root.css';
import { YbugProvider } from 'ybug-react';
import UserProvider from './Services/UserProvider';


function App() {
    return (
        <YbugProvider ybugId='7sv0s0h8cjg8fdkqh67q' >
            <UserProvider>
                <ThemeProvider theme={theme}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <SocketContext.Provider value={socket}>
                            <RootRouters />
                            <NotificationContainer />
                        </SocketContext.Provider>
                    </MuiPickersUtilsProvider>
                </ThemeProvider>
            </UserProvider>
        </YbugProvider >
    );
}
export default App;
